/* perama-custom.js v3
   Auto-scroll to top/gallery on mobile when a COLOUR variant is clicked.
   Built for Emerge (Troop) themes where scrolling may happen inside .layout--viewport.
*/

(function () {
  // Only run on product pages
  if (!document.body.classList.contains("template--product")) return;

  const DEBUG = true;

  function log(...args) {
    if (DEBUG) console.log("[PERAMA]", ...args);
  }

  function isMobile() {
    return window.matchMedia("(max-width: 1024px)").matches;
  }
  // If the viewport element is actually the one moving, use that
function getScroller() {
  return { type: "window", el: window };
}

  function getScrollTop(scroller) {
    if (scroller.type === "element") return scroller.el.scrollTop || 0;
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function setScrollTop(scroller, y) {
  window.scrollTo({ top: y, behavior: "smooth" });
}

  let animRaf = null;
  let cancelAnim = null;

  function stopAnimation(reason) {
    if (animRaf) cancelAnimationFrame(animRaf);
    animRaf = null;
    if (cancelAnim) cancelAnim(reason || "cancel");
    cancelAnim = null;
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function animateScrollTo(scroller, targetTop, durationMs) {
    stopAnimation("restart");

    const startTop = getScrollTop(scroller);
    const delta = targetTop - startTop;

    if (Math.abs(delta) < 2) {
      log("Already at target", { startTop, targetTop });
      return;
    }

    const duration = Math.max(900, Math.min(durationMs || 520, 900));
    const startTime = performance.now();

    const html = document.documentElement;
    const body = document.body;

    const prevOverflowAnchor = html.style.overflowAnchor;
    html.style.overflowAnchor = "none";

    let prevSnapType = "";
    if (scroller.type === "element") {
      prevSnapType = scroller.el.style.scrollSnapType;
      scroller.el.style.scrollSnapType = "none";
    } else {
      const prevBodySnap = body.style.scrollSnapType;
      const prevHtmlSnap = html.style.scrollSnapType;
      body.style.scrollSnapType = "none";
      html.style.scrollSnapType = "none";

      cancelAnim = () => {
        html.style.overflowAnchor = prevOverflowAnchor;
        body.style.scrollSnapType = prevBodySnap;
        html.style.scrollSnapType = prevHtmlSnap;
      };
    }

    if (scroller.type === "element") {
      cancelAnim = () => {
        html.style.overflowAnchor = prevOverflowAnchor;
        scroller.el.style.scrollSnapType = prevSnapType;
      };
    }

    function step(now) {
      const t = Math.min(1, (now - startTime) / duration);
      const eased = easeInOutCubic(t);
      const next = Math.round(startTop + delta * eased);

      setScrollTop(scroller, next);

      if (t < 1) {
        animRaf = requestAnimationFrame(step);
      } else {
        animRaf = null;
        if (cancelAnim) cancelAnim("done");
        cancelAnim = null;
      }
    }

    animRaf = requestAnimationFrame(step);
  }

  function getColorLabelFromEvent(e) {
    const label = e.target.closest("label.radios--value-button");
    if (!label) return null;

    const optionBlock = label.closest(
      '[data-option-name="color"],' +
      '[data-option-name="Color"],' +
      '[data-option-name="colour"],' +
      '[data-option-name="Colour"]'
    );
    if (!optionBlock) return null;

    return label;
  }

  let lastFire = 0;
  let lastLabelText = "";

  function requestScrollToTop(reason, labelText) {
    const now = Date.now();
    if (now - lastFire < 350 && labelText && labelText === lastLabelText) {
      return;
    }
    lastFire = now;
    lastLabelText = labelText || lastLabelText;

    setTimeout(function() {
      const start = window.pageYOffset;
      const duration = 900;
      const startTime = performance.now();

      function step(now) {
        const elapsed = now - startTime;
        const t = Math.min(elapsed / duration, 1);
        const eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        window.scrollTo(0, start * (1 - eased));
        if (t < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }, 100);
  }

  document.addEventListener(
    "change",
    function (e) {
      if (!isMobile()) return;

      const t = e.target;
      if (!t) return;

      const inColorBlock = t.closest(
        '[data-option-name="color"],' +
        '[data-option-name="Color"],' +
        '[data-option-name="colour"],' +
        '[data-option-name="Colour"]'
      );
      if (!inColorBlock) return;

      let labelText = "";
      if (t.tagName === "SELECT") {
        labelText = (t.value || "").trim();
      }

      requestScrollToTop("change", labelText);
    },
    true
  );
})();

/* ----------------------------------------
   PERAMA – Mobile Product Image Lightbox (JS)
   ---------------------------------------- */
(function () {
  function isMobile() {
    return window.matchMedia("(max-width: 1024px)").matches;
  }

  function onReady(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function closestAny(el, selectors) {
    for (const sel of selectors) {
      const hit = el.closest(sel);
      if (hit) return hit;
    }
    return null;
  }

  onReady(function () {
    // only product pages
    if (!document.body.classList.contains("template--product")) return;

    // Build overlay
    const overlay = document.createElement("div");
    overlay.className = "perama-image-lightbox";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.innerHTML = `
      <button class="perama-lightbox-close" aria-label="Close">
        <svg class="perama-lightbox-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 6L18 18M18 6L6 18"></path>
        </svg>
      </button>
      <button class="perama-lightbox-prev" aria-label="Previous">
        <svg class="perama-lightbox-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M14 6L8 12L14 18"></path>
        </svg>
      </button>
      <img alt="" />
      <button class="perama-lightbox-next" aria-label="Next">
        <svg class="perama-lightbox-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M10 6L16 12L10 18"></path>
        </svg>
      </button>
    `;
    document.body.appendChild(overlay);

    const imgEl = overlay.querySelector("img");
    const btnClose = overlay.querySelector(".perama-lightbox-close");
    const btnPrev = overlay.querySelector(".perama-lightbox-prev");
    const btnNext = overlay.querySelector(".perama-lightbox-next");

    // Find a sensible “gallery root” (Emerge + Shopify variants differ)
    const galleryRoot =
      document.querySelector("[data-product-media-gallery]") ||
      document.querySelector(".product__media") ||
      document.querySelector(".product__gallery") ||
      document.querySelector(".product-gallery") ||
      document.querySelector("main");

    function getGalleryImages() {
  if (!galleryRoot) return [];
  const candidates = Array.from(
    galleryRoot.querySelectorAll(
      "img"
    )
  );

  const imgs = candidates.filter((im) => {
    const w = im.naturalWidth || im.width || 0;
    const h = im.naturalHeight || im.height || 0;
    const src = im.currentSrc || im.src || "";
    if (!src) return false;
    if (src.includes("data:")) return false;
    if (im.classList.contains("perama-stamp")) return false;
    if (w && h && (w < 120 || h < 120)) return false;
    return true;
  });

  // De-dupe by URL
  const seen = new Set();
  const out = [];
  for (const im of imgs) {
    const src = im.currentSrc || im.src;
    if (seen.has(src)) continue;
    seen.add(src);
    out.push(src);
  }
  return out;
}

    let sources = [];
    let index = 0;
    let isOpen = false;

    function openAt(i) {
      if (!isMobile()) return;

      sources = getGalleryImages();
      if (!sources.length) return;

      index = Math.max(0, Math.min(i, sources.length - 1));
      imgEl.src = sources[index];

      overlay.classList.add("perama-image-lightbox--open");
      document.body.classList.add("perama-lightbox-open");
      isOpen = true;
    }

    function close() {
      overlay.classList.remove("perama-image-lightbox--open");
      document.body.classList.remove("perama-lightbox-open");
      imgEl.src = "";
      isOpen = false;
    }

    function prev() {
      if (!sources.length) return;
      index = (index - 1 + sources.length) % sources.length;
      imgEl.src = sources[index];
    }

    function next() {
      if (!sources.length) return;
      index = (index + 1) % sources.length;
      imgEl.src = sources[index];
    }

    // Close handlers
    btnClose.addEventListener("click", close);
    overlay.addEventListener("click", function (e) {
      // click outside image closes
      if (e.target === overlay) close();
    });
    document.addEventListener("keydown", function (e) {
      if (!isOpen) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    });

    // Nav handlers
    btnPrev.addEventListener("click", function (e) { e.stopPropagation(); prev(); });
    btnNext.addEventListener("click", function (e) { e.stopPropagation(); next(); });

    // Swipe
    let startX = 0;
    let startY = 0;
    overlay.addEventListener("touchstart", function (e) {
      if (!isOpen) return;
      const t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
    }, { passive: true });

    overlay.addEventListener("touchend", function (e) {
      if (!isOpen) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      if (Math.abs(dx) > 60 && Math.abs(dy) < 60) {
        if (dx > 0) prev();
        else next();
      }
    }, { passive: true });

    // Open when tapping gallery images (delegated)
    document.addEventListener("click", function (e) {
      if (!isMobile()) return;

      // only react if clicking an image inside the product gallery area
      const img = closestAny(e.target, [
        ".product__media img",
        ".product__gallery img",
        ".product-gallery img",
        "[data-product-media-gallery] img",
        "main img"
      ]);
      if (!img) return;

      // Avoid opening from UI icons etc.
      const src = img.currentSrc || img.src;
      if (!src) return;
      if (img.classList.contains("perama-stamp")) return;

      sources = getGalleryImages();
      if (!sources.length) return;

      const found = sources.indexOf(src);
      openAt(found >= 0 ? found : 0);
    });
  });
})();

/* ----------------------------------------
   PERAMA – Hero CTA smooth scroll to worlds grid
   ---------------------------------------- */
(function () {
  // Only run on homepage
  if (!document.body.classList.contains("template--index")) return;

  function onReady(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  onReady(function () {
    // Find the hero CTA button by its data-text attribute
    var btn = document.querySelector('.section-blocks--button[data-text="FIND YOUR AFFILIATION"]');
    if (!btn) return;

    btn.addEventListener("click", function (e) {
      // Find the video section this button lives in
      var videoSection = btn.closest(".shopify-section");
      if (!videoSection) return;

      // The collections grid is the next section down
      var target = videoSection.nextElementSibling;
      if (!target) return;

      e.preventDefault();

      // Smooth scroll with easing
      var start = window.pageYOffset;
      var end = target.getBoundingClientRect().top + start;
      var duration = 900;
      var startTime = performance.now();

      function ease(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function step(now) {
        var t = Math.min((now - startTime) / duration, 1);
        window.scrollTo(0, start + (end - start) * ease(t));
        if (t < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    });
  });
})();
